<template>
  <div class="ParticipantSearchBar">
    <div class="container-fluid">
        <div class="row margin-top-2Perc">
            <div class="col-md-6 col-lg-6 font-size-18px">
              <div class="row vertical-align">
                <div class="col-md-2 col-lg-2 Padding-left-32px">
                  Search
                </div>
                <div class="col-md-9 col-lg-9 width-69Perc">
                  <div class="form-group margin-bottom-0px">
                    <div class="icon-addon addon-lg">
                      <input type="text" class="form-control background-gray border-rounded" :disabled="disableBarAndFilter" v-model="enteredParticipantNameInSearchValue" autocomplete="off"/>
                      <label class="glyphicon glyphicon-search" :disabled="disableBarAndFilter"></label>
                    </div>
                  </div>
                </div>
                <div class="col-md-1 col-lg-1"></div>    
              </div>    
            </div>
            <div class="col-md-6 col-lg-6 text-align-left Padding-left-0px font-size-18px">        
              <div class="row vertical-align">
                <div class="col-md-3 col-lg-3 Padding-right-0px">
                  Filter By Group
                </div>
                <div class="col-md-8 col-lg-8 ">
                  <select class="form-control Padding-right-0px" v-model="selectedGroupObjValue" :disabled="disableBarAndFilter">
                    <option value=-1 disabled>Select</option>
                    <option v-for="groupObj in getGroupList" v-bind:key="groupObj.GroupId" v-bind:value="groupObj">{{ groupObj.GroupName }}</option>
                  </select>                  
                </div>
                <div class="col-md-1 col-lg-1 Padding-left-0px padding-top-0Point6Perc">
                  <img :src="resetIcon" alt="imgedit" height="20" width="20" class="img-opacity cursor-pointer" @click="resetFilterAndList">
                </div>
                </div>  
            </div> 
               
        </div>
    </div> 
    <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box>
    <!-- Show Spinner -->
    <div class="animationload" v-show="showSpinner">
      <div class="osahanloading"></div>
    </div>
    <loader></loader>   
  </div>
</template>

<script>
import Loader from '@/components/dashboard/Loader'
import { constants } from '@/utils/constants'
import AlertBox from '@/components/AlertOverlay'
import { groupService } from '@/server-util/group-service'
import reset from '../assets/images/reset.svg'
export default {
  props: ['disableBarAndFilter', 'resetEnteredSearchField', 'resetSearchBarFilterValues'],
  created: function () {
    this.getGroups()
  },
  data: function () {
    return {
      selectedGroupObj: -1,
      showAlertDialog: false,
      errorMsg: '',
      showSpinner: false,
      enteredParticipantNameInSearch: null,
      resetIcon: reset,
      timeoutId: null
    }
  },
  components: {
    'alert-box': AlertBox,
    'loader': Loader
  },
  methods: {
    resetFilterAndList: function () {
      if (this.selectedGroupObj !== -1) {
        this.selectedGroupObj = -1
        // this.$emit('searchString', '')
        this.$emit('resetFilter', true)
      } else {
        console.log('already showing select option in dropdown.')
      }
    },
    getGroups: function () {
      var storeObj = this.$store
      if (
        storeObj.state.access_token !== undefined ||
        storeObj.state.access_token !== null ||
        storeObj.state.access_token !== ''
      ) {
        groupService.listGroups(storeObj.state.access_token).then(
          responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Store it
              storeObj.state.groupList = responseObj.data
              // AK: Hide Spinner after recieving group list
              // _this.showSpinner = false
            } else {
              // AK: Hide Spinner
              // _this.showSpinner = false
              this.showAlertDialog = true
              this.errorMsg =
                'Oops! Something went wrong. Please try again.'
            }
          },
          errorObj => {
            // AK: Hide Spinner
            // _this.showSpinner = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          }
        )
      } else {
        console.log('Access Token is NULL hence declined LOADING GROUP LIST')
      }
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
    },
    findBy: function (list, value, column) {
      return list.filter(function (item) {
        // return item[column].includes(value)
        return String(item[column]).toLowerCase().indexOf(String(value).toLowerCase()) !== -1
      })
    }
  },
  computed: {
    getGroupList: {
      get: function () {
        return this.$store.state.groupList
      }
    },
    getEnrolledParticipantList: {
      get: function () {
        // AK: IF user is typing without applying group filter then return userlist
        if (this.enteredParticipantNameInSearch !== null && this.selectedGroupObj === -1) {
          return this.$store.state.userList
        } else {
          return this.$store.state.participantListForCurrentSelectedGroup
        }
      }
    },
    selectedGroupObjValue: {
      get: function () {
        return this.selectedGroupObj
      },
      set: function (newVal) {
        // this.enteredParticipantNameInSearch = null
        this.selectedGroupObj = newVal
        if (this.selectedGroupObj !== -1) {
          this.$emit('selectedGroupObj', this.selectedGroupObj)
        }
      }
    },
    enteredParticipantNameInSearchValue: {
      get: function () {
        return this.enteredParticipantNameInSearch
      },
      set: function (newVal) {
        this.enteredParticipantNameInSearch = newVal
        if (newVal !== null) {
          // this.selectedGroupObj = -1
          if (this.timeoutId != null) {
            clearTimeout(this.timeoutId)
          }
          var _this = this
          this.timeoutId = setTimeout(() => {
            if (_this.enteredParticipantNameInSearch !== null) {
              _this.$emit('searchString', _this.enteredParticipantNameInSearch)
            } else {
              _this.$emit('searchString', '')
            }
          }, 500)
        }
      }
    }
  },
  watch: {
    resetSearchBarFilterValues: function (newVal, oldVal) {
      if (newVal) {
        this.selectedGroupObj = -1
        this.enteredParticipantNameInSearchValue = null
      }
    },
    selectedGroupObj: function () {
      // AK: Reset filter if user selects new group
      // this.enteredParticipantNameInSearch = null
      // this.$emit('selectedGroupObj', this.selectedGroupObj)
    },
    enteredParticipantNameInSearch: function () {
      // this.selectedGroupObj = -1
      // if (this.timeoutId != null) {
      //   clearTimeout(this.timeoutId)
      // }
      // var _this = this
      // this.timeoutId = setTimeout(() => {
      //   if (_this.enteredParticipantNameInSearch !== null) {
      //     _this.$emit('searchString', _this.enteredParticipantNameInSearch)
      //   } else {
      //     _this.$emit('searchString', '')
      //   }
      // }, 500)
    },
    resetEnteredSearchField: function (newVal, oldVal) {
      this.enteredParticipantNameInSearch = null
      // AK: Reset flag to false again after clearing search input field
      this.$emit('updateResetEnteredSearchField', false)
    }
  },
  name: 'ParticipantSearchBar'
}
</script>

<style scoped>
.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.input-group .icon-addon .form-control {
  border-radius: 0;
}

.icon-addon {
  position: relative;
  color: #555;
  display: block;
}

.icon-addon:after,
.icon-addon:before {
  display: table;
  content: " ";
}

.icon-addon:after {
  clear: both;
}

.icon-addon.addon-md .glyphicon,
.icon-addon .glyphicon,
.icon-addon.addon-md .fa,
.icon-addon .fa {
  position: absolute;
  z-index: 2;
  left: 10px;
  font-size: 14px;
  width: 20px;
  margin-left: -2.5px;
  text-align: center;
  padding: 8px 0;
  top: 1px;
}

.icon-addon.addon-lg .form-control {
  line-height: 1.33;
  height: 30px;
  border-radius: 15px;
  font-size: 13px;
  padding: 7px 16px 6px 40px;
}

.icon-addon.addon-sm .form-control {
  height: 30px;
  padding: 5px 10px 5px 28px;
  font-size: 12px;
  line-height: 1.5;
}

.icon-addon.addon-lg .fa,
.icon-addon.addon-lg .glyphicon {
  font-size: 14px;
  margin-left: 0;
  left: 11px;
  top: 0px;
}

.icon-addon.addon-md .form-control,
.icon-addon .form-control {
  padding-left: 30px;
  float: left;
  font-weight: normal;
}

.icon-addon.addon-sm .fa,
.icon-addon.addon-sm .glyphicon {
  margin-left: 0;
  font-size: 12px;
  left: 5px;
  top: -1px;
}

.icon-addon .form-control:focus + .glyphicon,
.icon-addon:hover .glyphicon,
.icon-addon .form-control:focus + .fa,
.icon-addon:hover .fa {
  color: #2580db;
}
.border-color-red {
  border: 1px solid red;
}
.border-color-green {
  border: 1px solid green;
}
.width-70Perc {
  width: 70%;
}
.text-align-left {
  text-align: left !important;
}
.Padding-left-0px {
  padding-left: 0px !important;
}
.Padding-left-32px {
  padding-left: 32px !important;
}
.Padding-right-0px {
  padding-right: 0px !important;
}
.font-size-18px {
  font-size: 18px;
}
.margin-top-1Perc {
  margin-top: 1%;
}
.margin-top-2Perc {
  margin-top: 2%;
}
.margin-top-1Point4Perc {
  margin-top: 1.4%;
}
.margin-top-2-perc {
  margin-top: 2%;
}
.background-gray {
  background-color: #ddd;
}
.margin-bottom-0px {
  margin-bottom: 0px !important;
}
.gray-border {
  border: 1px solid #aaa;
}
.white-BG {
  background-color: #ffffff;
}
.margin-top-3-perc {
  margin-top: 3%;
}
.margin-top-1-perc {
  margin-top: 1%;
}
.right-border-color {
  /*border-right: 1px solid #43495e;*/
}
.vertical-align {
  display: flex;
  align-items: center;
}
.width-69Perc {
  width: 69% !important;
}
.cursor-pointer {
  cursor: pointer;
}
.width-9-Perc {
  width: 9% !important;
}
@media (max-width: 1024px) {
  .width-9-Perc {
    width: 11.5% !important;
  }
}
.font-weight-bold
{
  font-weight: bold;
}
.font-size-15px
{
  font-size: 15px;
}
.img-opacity{
  opacity:0.7;
}
.margin-bottom-1{
  margin-bottom:1%;
}
.padding-top-1Perc{
  padding-top:1%;
}
.padding-top-0Point6Perc{
  padding-top:0.6%;
}
.margin-Left-4Perc{
  margin-left:4% !important;
}
</style>



// WEBPACK FOOTER //
// src/components/ParticipantSearchBar.vue